import axios from 'axios';


const login = async (inputs) => {
    const response = await axios.post("/api/auth/login", inputs);
    if (response.data) {
        localStorage.setItem('user', JSON.stringify(response.data));
    }
    console.log(response.data);
    return response.data;
};





const loginQR = async (inputs) => {
    const response = await axios.post("/api/auth/login/qr", inputs);
    if (response.data) {
        localStorage.setItem('user', JSON.stringify(response.data));
    }
    console.log(response.data);
    return response.data;
};





const logout = async () => {
    try {
      await axios.post("/api/auth/logout");
      localStorage.removeItem("user");
      console.log("Logged out successfully (client-side cleared)");
    } catch (err) {
      console.error("Logout failed:", err);
    }
  };
  
  const getCurrentUser = async () => {
    try {
      const response = await axios.post("/api/auth/checkAuth");
      
      if (response.status === 200 && response.data.user) {
        return response.data.user; 
      }
  
      localStorage.removeItem("user");
      return null;
    } catch (error) {
      localStorage.removeItem("user");
      if (error.response?.status === 401) {
        console.log("No active session!");
        return null;
      }
      console.error("getCurrentUser failed:", error);
      return null;
    }
  };
  
  
export default {
    login,
    loginQR,
    logout,
    getCurrentUser
};